import { TextField, Stack } from '@collaborate-health/uikit'
import { memo } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import { updateUsersSearchValue } from '@tabeeb/modules/sessionsPage/actions'
import { getSelectedTenant, getSelectedUser } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import SearchUsersResult from '../SearchUsersResult'

interface SearchUserInputProps {
  contentSharingType: ContentSharingModelType
}

const SearchUserInput: React.FC<SearchUserInputProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))
  const selectedUser = useSelector((state) => getSelectedUser(state, { contentSharingType }))
  const usersSearchInputValue = useSelector((state) => state.sessionsPage.usersSearchInputValue)

  const _handleChange = (e) => {
    const searchText = e.target.value
    dispatch(updateUsersSearchValue({ searchText, tenantId: selectedTenant?.Id }))
  }

  if (!selectedTenant?.Id || selectedUser) {
    return null
  }

  return (
    <Stack spacing={1}>
      <TextField
        fullWidth
        value={usersSearchInputValue}
        onChange={_handleChange}
        placeholder='Search name or email...'
      />
      <SearchUsersResult />
    </Stack>
  )
}

export default memo(SearchUserInput)

